//jsxhook

import { ZoomGallery, ZoomGalleryImage } from "@sixty-six-north/ui-system"
import React from "react"

export const ZoomGalleryModal: React.FC<{
  images: Array<ZoomGalleryImage>
  show: boolean
  currentPage?: number
  onClose: () => void
}> = ({ currentPage, images, onClose, show }) => (
  <ZoomGallery
    show={show}
    currentPage={currentPage}
    close={onClose}
    images={images}
  />
)
